


import { createSlice } from "@reduxjs/toolkit";

const loginRegularJourneySlice = createSlice({
    name: 'loginRegularJourney',
    initialState: '',
    reducers: {
        updateLoginRegularJourneyStep: (state, action): any => {
            const newState = action.payload
            return newState

        },
    },
});
export const { updateLoginRegularJourneyStep } = loginRegularJourneySlice.actions;
export default loginRegularJourneySlice.reducer;